"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _title = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/title.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _title.default);
/** Use an **Title** component to display a title or heading. Note that only one H1 should appear on a page, and headings should only appear in ascending order without skipping a level; i.e. even if there are only 3 levels on a page, the order must be H1-H2-H3, and no other levels used. */

var Title = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _context;

  var className = _ref.className,
      children = _ref.children,
      cssNamespace = _ref.cssNamespace,
      level = _ref.level,
      levelStyle = _ref.levelStyle,
      wrap = _ref.wrap,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "children", "cssNamespace", "level", "levelStyle", "wrap"]);
  var levelClass = levelStyle ? "h".concat(levelStyle) : "h".concat(level);
  var headingClasses = classnames("".concat(cssNamespace, "-title"), (0, _concat.default)(_context = "".concat(cssNamespace, "-title--")).call(_context, levelClass), (0, _defineProperty2.default)({}, "".concat(cssNamespace, "-title--wrap"), !!wrap), className);
  var HeadingTag = "h".concat(level);
  return /*#__PURE__*/_react.default.createElement(HeadingTag, (0, _extends2.default)({}, props, {
    className: headingClasses,
    ref: ref
  }), children);
});

Title.displayName = 'Title';
process.env.NODE_ENV !== "production" ? Title.propTypes = {
  /** Determines the heading tag rendered on the page, also known as the semantic level of the heading. */
  level: _CustomPropTypes.default.range(1, 6).isRequired,

  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** If the desired visual appearance is different from the default style given to the semantic level of the header, provide the desired heading level style to apply. */
  levelStyle: _CustomPropTypes.default.range(1, 6),

  /** Set to **true** if the Title text should wrap instead of truncate. */
  wrap: _propTypes.default.bool
} : void 0;

var _default = (0, _withStyles.default)(Title);

exports.default = _default;